module.exports = __webpack_public_path__ + "img/home_cont2.1797a8c3.png";